import { render, staticRenderFns } from "./PrincipalOverrideEditDialog.vue?vue&type=template&id=3887a11c&scoped=true"
import script from "./PrincipalOverrideEditDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalOverrideEditDialog.vue?vue&type=script&lang=js"
import style0 from "./PrincipalOverrideEditDialog.vue?vue&type=style&index=0&id=3887a11c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887a11c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3887a11c')) {
      api.createRecord('3887a11c', component.options)
    } else {
      api.reload('3887a11c', component.options)
    }
    module.hot.accept("./PrincipalOverrideEditDialog.vue?vue&type=template&id=3887a11c&scoped=true", function () {
      api.rerender('3887a11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PrincipalOverrideEditDialog.vue"
export default component.exports